import { OptimizelyContext } from '@optimizely/react-sdk';
import { useCallback, useContext } from 'react';
import { IFeatureFlagManager } from 'v2/core/clients/featureFlag/types';
import { User } from 'v2/core/entities/user';

const useGetOptimizelyFeatureFlagManager = (): IFeatureFlagManager => {
  const { optimizely } = useContext(OptimizelyContext);

  const setUser = useCallback(
    (user: User) => {
      optimizely?.setUser({
        id: user.email,
        attributes: {
          email: user.email,
          userID: user.id,
          tenantID: user.tenant.id,
          tenantName: user.tenant.name,
          firstName: user.firstName,
          lastName: user.lastName,
          tier: user.tenant.tier,
        },
      });
    },
    [optimizely],
  );
  return {
    setUser,
    optimizelyInstance: optimizely,
  };
};

export default useGetOptimizelyFeatureFlagManager;
